type NetworkingMapBandLabelTooltipProps = {
  text: string;
  x: number;
  y: number;
};

export default function NetworkingMapBandLabelTooltip({
  text,
  x,
  y,
}: NetworkingMapBandLabelTooltipProps) {
  return (
    <div
      className="pointer-events-none absolute z-30 min-w-[200px] max-w-[240px] -translate-x-full rounded bg-gray-font px-2.5 py-2 text-left text-xs font-normal leading-snug text-neutral"
      style={{ left: x, top: y }}
      role="tooltip"
    >
      {text}
    </div>
  );
}
